<nav
  class="beta-menu"
  aria-label="Primary"
  [class.is-open]="isMenuOpen"
  [class.is-pinned]="isPinnedOpen"
>
  <div #rail class="beta-menu-rail" role="menubar" aria-orientation="vertical">
    <ul class="beta-menu-rail-list" role="list">
      <li>
        <div
          class="beta-menu-branding"
          [routerLink]="['/ai/clarichat']"
          role="button"
          aria-label="ClariChat home"
          [attr.title]="isPinnedOpen ? 'Close' : 'Open'"
          [attr.aria-pressed]="isPinnedOpen"
          (click)="togglePinnedOpen($event)"
        >
          <img src="assets/svg/sosexy.png" class="beta-menu-logo" alt="" aria-hidden="true" />
          <span class="beta-menu-open-indicator" aria-hidden="true">
            <i class="fa-solid fa-square-caret-right"></i>
            <span class="beta-menu-open-tooltip">Opened</span>
          </span>
        </div>
      </li>

      <ng-container *ngFor="let section of sections; trackBy: trackBySection">
        <li>
          <button
            class="beta-menu-icon"
            type="button"
            [routerLink]="section.railRoute ? [section.railRoute] : null"
            role="menuitem"
            [attr.aria-label]="section.title"
            [attr.aria-current]="section.id === activeSectionId ? 'true' : null"
            (focus)="setActiveSection(section.id)"
            (click)="onIconClick(section.id)"
          >
            <span
              *ngIf="section.id === 'instruments' && section.iconSrc"
              class="beta-menu-rail-icon beta-menu-rail-icon--guitar"
              [ngStyle]="{
                '-webkit-mask-image': 'url(' + section.iconSrc + ')',
                'mask-image': 'url(' + section.iconSrc + ')'
              }"
              role="img"
              [attr.aria-label]="section.iconAlt || section.title"
            ></span>
            <img
              *ngIf="section.id !== 'instruments' && section.iconSrc"
              [src]="section.iconSrc"
              [alt]="section.iconAlt || section.title"
            />
            <i *ngIf="section.iconClass" [class]="section.iconClass" aria-hidden="true"></i>
          </button>
        </li>
      </ng-container>
    </ul>
  </div>

  <aside #panel class="beta-menu-panel" aria-live="polite">
    <div
      class="beta-menu-panel-inner"
      [style.--beta-menu-text-scale]="textSizeScale"
      [style.--beta-menu-icon-scale]="iconSizeScale"
    >
      <header class="beta-menu-header" [attr.data-active-section]="activeSectionId">
        <div class="beta-menu-frozen" *ngIf="isPinnedOpen">
          <i class="fa-solid fa-lock" aria-hidden="true"></i>
          <span>Locked</span>
        </div>
        <div class="beta-menu-title">
          <span
            *ngIf="activeSection.id === 'instruments' && activeSection.iconSrc"
            class="beta-menu-panel-title-icon beta-menu-rail-icon beta-menu-rail-icon--guitar"
            [ngStyle]="{
              '-webkit-mask-image': 'url(' + activeSection.iconSrc + ')',
              'mask-image': 'url(' + activeSection.iconSrc + ')'
            }"
            role="img"
            [attr.aria-label]="activeSection.iconAlt || activeSection.title"
          ></span>
          <i *ngIf="activeSection.id !== 'instruments' && activeSection.id !== 'chat'" [ngClass]="getSectionIconClass()"></i>
          {{ activeSection.title }}
        </div>
        <div class="beta-menu-subtitle">{{ activeSection.subtitle }}</div>
      </header>

      <div class="beta-menu-links-wrapper">
        <ul class="beta-menu-links is-active" role="list" [attr.data-section-id]="activeSectionId">

          <li *ngFor="let link of activeSection.links; trackBy: trackByLink">
            <a
              class="beta-menu-link"
              [routerLink]="[link.route]"
              routerLinkActive="active"
              #linkActive="routerLinkActive"
              [attr.data-link-route]="link.route"
              (click)="onAuthLinkClick($event, link)"
            >
              <span>
                <i *ngIf="link.iconClass" [class]="link.iconClass" aria-hidden="true"></i>
                {{ link.label === 'Log In' ? ((authState$ | async) ? 'Logout' : 'Log In') : link.label }}
              </span>
              <img
                *ngIf="linkActive.isActive"
                class="beta-link-active-indicator"
                src="assets/hereiam.svg"
                alt=""
                aria-hidden="true"
              />
            </a>
          </li>

          <li class="beta-conversation-history-header"
              *ngIf="(authState$ | async) && recentConversations.length > 0">
            <div class="beta-conversation-history-divider"></div>
            <div class="aliconvo">Your Chats</div>
          </li>

          <li
            class="beta-conversation-item"
            *ngFor="let conv of recentConversations; trackBy: trackByConversationId"
            (mouseenter)="hoveredConversationId = conv.id"
            (mouseleave)="hoveredConversationId = null"
          >
            <div
              class="beta-menu-link beta-conversation-link"
              *ngIf="editingTopicId !== conv.id"
              [routerLink]="['/ai/clarichat']"
              (click)="!editingTopicId && loadConversation(conv.id)"
            >
              <div class="beta-conversation-content">
                <div class="beta-conversation-line">
                  <i class="fa fa-message fa-message-ali">&nbsp;{{ conv.messages?.length || 0 }}&nbsp;</i>
                  <span class="beta-conversation-topic" [title]="conv.topic || 'Conversation'">
                    {{ truncateTopic(conv.topic || 'Classified Chat') }}
                  </span>
                  <button
                    class="beta-conversation-edit-btn"
                    *ngIf="!editingTopicId"
                    (click)="startEditingTopic(conv.id, conv.topic || ''); $event.stopPropagation()"
                    type="button"
                    aria-label="Edit topic"
                  >
                    <i class="fa-regular fa-pen-to-square"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="beta-conversation-edit-mode" *ngIf="editingTopicId === conv.id">
              <input
                type="text"
                class="beta-conversation-topic-input"
                [(ngModel)]="editingTopicValue"
                (keydown.enter)="saveTopic(conv.id)"
                (keydown.escape)="cancelEditingTopic()"
                (blur)="saveTopic(conv.id)"
                maxlength="60"
                placeholder="Enter topic..."
              />
              <div class="beta-conversation-edit-actions">
                <button class="beta-conversation-save-btn" (click)="saveTopic(conv.id)"
                        type="button" aria-label="Save">
                  <i class="fa-solid fa-check"></i>
                </button>
                <button class="beta-conversation-cancel-btn" (click)="cancelEditingTopic()"
                        type="button" aria-label="Cancel">
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
          </li>

          <li class="beta-conversation-loading" *ngIf="(authState$ | async) && loadingConversations">
            <div>Loading conversations...</div>
          </li>

        </ul>
      </div>
    </div>
  </aside>
</nav>